import { RouteItem } from '@eastcoal/router/types/route'

import {
  PRICE_INDEX_CATEGORY_PATH,
  PRICE_INDEX_CREATE_PATH,
  PRICE_INDEX_EDIT_PATH,
  PRICE_INDEX_LIST_PATH
} from './constants/path'
import {
  PRICE_INDEX_ACTION_UUID,
  PRICE_INDEX_CATEGORY_PAGE_UUID,
  PRICE_INDEX_LIST_PAGE_UUID
} from './constants/uuid'

export const priceIndexRoute: RouteItem = {
  title: '指数走势',
  uuid: PRICE_INDEX_LIST_PAGE_UUID,
  hideChildrenInMenu: true,
  children: [
    {
      title: '列表',
      path: PRICE_INDEX_LIST_PATH,
      Component: () => import('./List')
    },
    {
      title: '新增指数',
      path: PRICE_INDEX_CREATE_PATH,
      Component: () => import('./Create')
    },
    {
      title: '编辑指数',
      path: PRICE_INDEX_EDIT_PATH,
      Component: () => import('./Edit')
    },
    {
      title: '类别管理',
      path: PRICE_INDEX_CATEGORY_PATH,
      uuid: PRICE_INDEX_CATEGORY_PAGE_UUID,
      Component: () => import('./Category/List')
    },
    {
      title: '管理指数',
      uuid: PRICE_INDEX_ACTION_UUID
    }
  ]
}
